import type { MembershipPackage } from "@/shared/services/vendor-requests.api";

export const MEMBERSHIP_PACKAGES_PRESETS: MembershipPackage[] = [
  {
    id: "1",
    label: "Starter",
    price_monthly: 19,
    price_yearly: 190,
    highlight: "Best for getting started and receiving leads in your area.",
    features: ["Basic vendor profile", "Access to nearby leads", "Email notifications"],
  },
  {
    id: "2",
    label: "Pro",
    price_monthly: 39,
    price_yearly: 390,
    highlight: "Grow faster with priority placement and more lead capacity.",
    features: [
      "Everything in Starter",
      "Priority listing in search",
      "Higher lead limit",
      "Featured badge",
    ],
  },
  {
    id: "3",
    label: "Enterprise",
    price_monthly: 99,
    price_yearly: 990,
    highlight: "For teams that need advanced support and account management.",
    features: [
      "Everything in Pro",
      "Dedicated account manager",
      "Team access",
      "Custom onboarding",
    ],
  },
];
